/* COMPONENT - C07.03 Cookie banner 1.0 */
'use strict';

export default class CookieBanner {
    constructor(element) {
        this.root = element;
        this.button = this.root.querySelector('.cta');
        this.docClick = this.setCookie.bind(this);
        this.bindEvents();
        this.checkCookie();
    }

    setCookie() {
        let date = new Date();
        
        date.setTime(date.getTime()+(365*24*60*60*1000));
        document.cookie = 'cookies=true ; expires=' +date.toGMTString();
        this.root.classList.remove('cookie-banner--show');
        document.removeEventListener('click', this.docClick);
        return false;
    }

    checkCookie() {
        if (document.cookie.indexOf('cookies=') < 0) {
            this.root.classList.add('cookie-banner--show');
            document.addEventListener('click', this.docClick);
        }
    }

    bindEvents() {
        this.button.addEventListener('click', this.setCookie.bind(this));
    }
}
